import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment, Component, createRef } from "react";
import classnames from "classnames";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  Badge,
} from "reactstrap";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import TableActiveComponent from "./Components/TableActiveComponent";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { AvForm, AvField } from "availity-reactstrap-validation";
import apiResponse from "../../../../services/apiResponse";
import DataTableBloc from "./Blocs/DataTableBloc";
import moment from "moment";

class IndexView extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;
  role = localStorage.getItem("currentRoleId");
  dataTableBloc = new DataTableBloc();
  constructor(props) {
    super(props);
    this.state = {
      confirmInfo: "Apakah anda yakin akan menyimpan data ini?",
      failedInfo: "Data gagal disimpan",
      failedTitle: "Gagal!",
      dataForm: {},
      fileUrl: "",
      modal: false,
      monthOptions: this.createMonthOptions(),
      yearOptions: this.createYearOption(new Date().getFullYear() - 30),
      month: localStorage.getItem(this.historyMonth)
        ? JSON.parse(localStorage.getItem(this.historyMonth))
        : moment().format("M"),
      year: localStorage.getItem(this.historyYear)
        ? JSON.parse(localStorage.getItem(this.historyYear))
        : moment().format("YYYY"),
    };
    this.activeRef = createRef();
  }
  createMonthOptions() {
    var months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    return months.map(function (month, i) {
      var newObj = {};
      newObj["label"] = month;
      newObj["value"] = ++i;

      return newObj;
    });
  }
  createYearOption(startYear = 2000) {
    var currentYear = new Date().getFullYear(),
      years = [];
    startYear = startYear || 1980;
    while (startYear <= currentYear) {
      var newObj = {};
      var year = startYear++;
      newObj["label"] = year;
      newObj["value"] = year;
      years.push(newObj);
    }
    return years;
  }

  getMonthName(monthNumber) {
    const monthNamesId = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];

    if (monthNumber >= 1 && monthNumber <= 12) {
      return monthNamesId[monthNumber - 1];
    } else {
      return "Invalid Month";
    }
  }

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
        special_allowance_summary_month: this.state.month,
        special_allowance_summary_year: this.state.year,
      },
      confirm: true,
      fileUrl: "",
      modal: false,
    });
  };

  submitData = async () => {
    await this.createBloc.fetchCreate(
      this.convertToFormData(this.state.dataForm)
    );
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };

        this.submitData();

        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          showUpload: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    // this.createBloc.createChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED: {
    //       const res = result.data;
    //       if (res && res.status === true) {
    //         this.setState({
    //           loading: false,
    //           success: true,
    //           failed: false,
    //         });
    //         this.activeRef.current.setTokenAPI();
    //       } else {
    //         this.setState({
    //           loading: false,
    //           failed: true,
    //           success: false,
    //           failedTitle: "Gagal",
    //           failedInfo: res?.message || "Terjadi kesalahan",
    //         });
    //       }
    //       break;
    //     }
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //         failedTitle: "Error",
    //         failedInfo: "Gagal menghubungi server",
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });
  }

  componentWillUnmount() {
    // this.createBloc.createChannel?.unsubscribe();
    this.dataTableBloc.exportChannel?.unsubscribe();
  }

  handleButtonExport() {
    this.setState({ modal: true });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            const response = result.data.response;
            window.open(response.file_url, "_blank");
            this.setState({ modal: false });
          }
          break;

        case apiResponse.ERROR:
          this.setState({ modal: false });
          break;

        default:
          break;
      }
    });

    this.dataTableBloc.fetchExport({});
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Daftar Pemadanan Data Gaji Web</CardTitle>
                  <CardSubtitle className="mb-3">
                    Kelola Daftar Pemadanan Data Gaji Web
                  </CardSubtitle>
                  <hr />

                  {/* <Row className="mb-3">
                    <label htmlFor="no_skx" className="col-md-2 col-form-label">
                      Periode <span className="text-danger">*</span>
                    </label>
                    <Col md="2">
                      <CustomSelect
                        name="period_month"
                        errorMessage="Pilih Bulan"
                        options={this.state.monthOptions}
                        placeholder="Pilih Bulan"
                        defaultValue={this.state.month}
                        onChange={(v) => {
                          this.setState({ month: v.value });
                          this.handleperiodePenilaian(v.value, this.state.year);
                        }}
                        isAvForm={false}
                      />
                    </Col>
                    <Col md="2">
                      <CustomSelect
                        name="period_year"
                        errorMessage="Pilih Tahun"
                        options={this.state.yearOptions}
                        placeholder="Pilih Tahun"
                        defaultValue={this.state.year}
                        onChange={(v) => {
                          this.setState({ year: v.value });
                          this.handleperiodePenilaian(
                            this.state.month,
                            v.value
                          );
                        }}
                        isAvForm={false}
                      />
                    </Col>
                  </Row> */}

                  <Row className="mb-3">
                    {/* <Col md="2"></Col> */}
                    <Col md="10">
                      {/* <Button
                        color="primary"
                        type="button"
                        // onClick={() => {
                        //   handleButtonSearch();
                        // }}
                      >
                        <i className="uil-search-alt"></i> Cari
                      </Button>{" "}
                      <Button
                        color="warning"
                        type="button"
                        // onClick={() => {
                        //   handleButtonReset();
                        // }}
                      >
                        <i className="uil-excel"></i> Reset
                      </Button>{" "} */}
                      <Button
                        style={{ backgroundColor: "green" }}
                        type="button"
                        onClick={() => {
                          this.handleButtonExport();
                        }}
                      >
                        Download Excel Pemadanan Data
                      </Button>{" "}
                      <Button
                        color="secondary"
                        type="button"
                        // onClick={() => {
                        //   setConfirm(true);
                        //   // togglePopupExport('open')
                        // }}
                      >
                        Kirim Data Pemadanan Pegawai
                      </Button>{" "}
                      <Button
                        color="secondary"
                        type="button"
                        // onClick={() => {
                        //   setConfirm(true);
                        //   // togglePopupExport('open')
                        // }}
                      >
                        Kirim Data Pemadanan Keluarga
                      </Button>{" "}
                    </Col>
                  </Row>

                  <hr />
                  <TableActiveComponent
                    ref={this.activeRef}
                    // setDocument={(doc) => this.setState({ document: doc })}
                    // additionalFilter={{
                    //   year: this.state.year,
                    //   month: this.state.month,
                    //   workunit: this.state.workUnitSelected,
                    //   employee_uuid: this.state.atasanSelected,
                    // }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo={this.state.confirmInfo}
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil disimpan"
            failedTitle={this.state.failedTitle}
            failedInfo={this.state.failedInfo}
            alertInfo="aaaaaaaaaaaaaa"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />
        </Container>
      </Fragment>
    );
  }
}

export default IndexView;
